import { create } from 'zustand';

export const useParcelStore = create((set) => ({
  parcels: [],
  selectedParcel: null,
  setParcels: (parcels) => set({ parcels }),
  addParcel: (parcel) => set((s) => ({ parcels: [...s.parcels, parcel] })),
  updateParcel: (id, data) =>
    set((s) => ({
      parcels: s.parcels.map((p) => (p.id === id ? { ...p, ...data } : p)),
    })),
  removeParcel: (id) =>
    set((s) => ({ parcels: s.parcels.filter((p) => p.id !== id) })),
  setSelectedParcel: (parcel) => set({ selectedParcel: parcel }),
}));
